import { Flummox } from 'flummox';
import AppStateActions from 'actions/AppStateActions';
import CodeFormActions from 'actions/CodeFormActions';
import AppStateStore from 'stores/AppStateStore';
import CodeFormStore from 'stores/CodeFormStore';
import ContestDataStore from 'stores/ContestDataStore';

class Flux extends Flummox {
  constructor(baseUrl = '') {
    super();

    this.baseUrl = baseUrl;
    this.createActions('appState', AppStateActions);
    this.createActions('codeForm', CodeFormActions);
    this.createStore('appState', AppStateStore, this);
    this.createStore('codeForm', CodeFormStore, this);
    this.createStore('contestData', ContestDataStore, this);

    this.ready = Promise.all([this.getStore('contestData').ready]).then(
      () => true
    );
  }
}

export default Flux;



// WEBPACK FOOTER //
// ./src/Flux.js